const vueFb = {}

vueFb.install = function install (Vue, options) {
  (function (d, s, id) {
    let js = d.getElementsByTagName(s)[0]
    let fjs = d.getElementsByTagName(s)[0]
    if (d.getElementById(id)) return
    js = d.createElement(s)
    js.id = id
    js.src = 'https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js'
    fjs.parentNode.insertBefore(js, fjs)
    console.log('setting fb sdk')
  }(document, 'script', 'facebook-jssdk'))

  window.fbAsyncInit = function onSDKInit () {
    window.FB.init(options)
    window.FB.AppEvents.logPageView()
    window.dispatchEvent(new Event('fb-sdk-ready'))
  }
}

export default vueFb



// WEBPACK FOOTER //
// ./src/helpers/facebookSdk.js